
      import API from "!../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.9/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.9/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.9/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.9/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.9/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.9/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.6.1_@swc+helpers@0.5.17__webpack@5.99.9/node_modules/css-loader/dist/cjs.js!../../node_modules/.pnpm/sass-loader@16.0.6_@rspack+core@1.6.1_@swc+helpers@0.5.17__sass-embedded@1.93.3_sass@1.93.3_webpack@5.99.9/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./application_standalone.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.6.1_@swc+helpers@0.5.17__webpack@5.99.9/node_modules/css-loader/dist/cjs.js!../../node_modules/.pnpm/sass-loader@16.0.6_@rspack+core@1.6.1_@swc+helpers@0.5.17__sass-embedded@1.93.3_sass@1.93.3_webpack@5.99.9/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./application_standalone.scss";
       export default content && content.locals ? content.locals : undefined;
